import React from 'react';
import { useQuery } from 'react-query';
import { User, checkConnectionStatus, ConnectionStatus } from '../../../services/userService';
import UserMarker from './UserMarker'; // Import the presentation component

// Define props expected by the wrapper
interface UserMarkerWrapperProps {
  user: User;
  isCurrentUser?: boolean;
  onSendMessage?: (userId: number, userName: string) => void;
  onSendWave?: (userId: number) => void;
  onConnect?: (userId: number, userName: string) => void;
}

const UserMarkerWrapper: React.FC<UserMarkerWrapperProps> = ({
  user,
  isCurrentUser = false,
  onSendMessage,
  onSendWave,
  onConnect,
}) => {
  // Query key includes the user ID for specificity
  const queryKey: [string, number] = ['connectionStatus', user.id];

  // Use useQuery to fetch the status for this specific user
  const { 
    data: status,
    isLoading: isLoadingStatus
  } = useQuery<ConnectionStatus, Error>(
    queryKey,
    () => checkConnectionStatus(user.id),
    {
      enabled: !isCurrentUser, // Only fetch for users other than the current one
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false, // Optional: prevent refetch on focus
      onError: () => {
        console.error(`UserMarkerWrapper: Failed to fetch connection status for user ${user.id}`);
      },
      // onSuccess: (fetchedStatus) => {
      //   console.log(`UserMarkerWrapper: Fetched status for user ${user.id} (${user.name}):`, fetchedStatus);
      // }
    }
  );

  // Render the actual UserMarker, passing the fetched status down
  return (
    <UserMarker
      key={user.id}
      user={user}
      isCurrentUser={isCurrentUser}
      onSendMessage={onSendMessage}
      onSendWave={onSendWave}
      onConnect={onConnect}
      connectionStatus={isLoadingStatus ? undefined : status}
    />
  );
};

export default UserMarkerWrapper; 